var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[(_vm.isLogin && _vm.IsWap)?_c('div',{staticClass:"login-after-box"},[_c('div',{staticClass:"hello-msg-box"},[_c('span',[_vm._v("欢迎您，")]),_c('span',[_vm._v(_vm._s(_vm.name))])]),_c('a',{on:{"click":_vm.doLogout}},[_vm._v("退出")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }